"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

export function PortalLoginForm({ orgName }: { orgName: string }) {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    const res = await fetch("/api/portal/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    setLoading(false);
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      setError(body.error ?? "Could not sign in.");
      return;
    }
    router.push("/portal");
    router.refresh();
  }

  return (
    <div
      className="flex-1 flex items-center justify-center px-4"
      style={{ background: "var(--bg)" }}
    >
      <div
        className="w-full max-w-sm rounded-xl border p-8 shadow-sm"
        style={{ background: "var(--surface)", borderColor: "var(--line)" }}
      >
        <div className="mb-6">
          <div className="text-lg font-semibold" style={{ color: "var(--accent-strong)" }}>
            {orgName}
          </div>
          <p className="text-sm mt-1" style={{ color: "var(--ink-muted)" }}>
            Customer portal — track your shipments and invoices.
          </p>
        </div>
        <form onSubmit={onSubmit} className="flex flex-col gap-4">
          <label className="flex flex-col gap-1 text-sm">
            <span style={{ color: "var(--ink-muted)" }}>Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-md border px-3 py-2 outline-none"
              style={{ borderColor: "var(--line-strong)", background: "var(--bg)" }}
              placeholder="you@company.com"
            />
          </label>
          <label className="flex flex-col gap-1 text-sm">
            <span style={{ color: "var(--ink-muted)" }}>Password</span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-md border px-3 py-2 outline-none"
              style={{ borderColor: "var(--line-strong)", background: "var(--bg)" }}
            />
          </label>
          {error && (
            <div className="text-sm rounded-md px-3 py-2" style={{ color: "var(--crit)", background: "var(--crit-soft)" }}>
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="rounded-md py-2 font-medium mt-1 disabled:opacity-60"
            style={{ background: "var(--accent)", color: "white" }}
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
